// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewEmployeeInformation_wrapper__iSP9C","informationSections":"ViewEmployeeInformation_informationSections__uInxP","close":"ViewEmployeeInformation_close__J7Cem"};